import * as React from 'react';

// Redux
import { combineReducers, createStore } from 'redux';

// Navigation Reducer
import navigationReducer from './reducers/navigation/NavigationReducer';
import * as actionNavigation from './reducers/navigation/ActionsNavigation';

// User Reducer
import userReducer from './reducers/user/UserReducer';
import * as actionsUser from './reducers/user/ActionsUser';

// OverlayReducer
import overlayReducer from "./reducers/overlay/OverlayReducer";
import * as actionsOverlayReducer from "./reducers/overlay/ActionsOverlayReducer";

// NotificationReducer
import notificationReducer from "./reducers/notification/NotificationReducer";
import * as actionsNotificationReducer from "./reducers/notification/ActionsNotificationReducer";

// Managers
import { NetworkManager } from './../managers/NetworkManager';

/**
 * Store mapper
 */
const store = createStore(combineReducers({
    navigation: navigationReducer,
    notification: notificationReducer,
    overlay: overlayReducer,
    user: userReducer
}));

/**
 * @description Redux MainStore
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class MainStore
 */
export class MainStore {

    /**
     * @description Return the Redux store
     * @author Lucas Fridez <lucas@fridez.dev>
     * @static
     * @returns redux store
     * @memberof MainStore
     */
    public static getStore() {
        return store;
    }

    /**
     * @description Login a User
     * @author Lucas Fridez <lucas@fridez.dev>
     * @static
     * @param {any} user user that will be logged in
     * @memberof MainStore
     */
    public static loginUser(user: any) {
        this.getStore().dispatch({
            type: actionsUser.USER_LOGIN_SUCCESS,
            value: user
        });
    }

    /**
     * @description Login with error
     * @author Lucas Fridez <lucas@fridez.dev>
     * @static
     * @memberof MainStore
     */
    public static loginUserError() {
        this.getStore().dispatch({
            type: actionsUser.USER_LOGIN_ERROR
        });
    }

    public static logoutUser() {
        return (e: React.MouseEvent<any>) => {
            NetworkManager.disconnect();
            this.getStore().dispatch({
                type: actionsUser.USER_LOGOUT,
                value: false
            });
        };
    }

    /**
     * @description Show or hide the Drawer Component
     * @author Lucas Fridez <lucas@fridez.dev>
     * @static
     * @param {boolean} isNavigationVisible the inverse value which will be setted
     * @returns {(((event: React.MouseEvent<any>) => void | undefined))}
     * @memberof MainStore
     */
    public static toggleNavigation(isNavigationVisible: boolean): ((event: React.MouseEvent<any>) => void | undefined) {
        return (e: React.MouseEvent<any>) => {
            this.getStore().dispatch({
                type: actionNavigation.NAVIGATION_TOGGLE,
                value: !isNavigationVisible
            });
        };
    }

    public static updateActualView(newView: string): ((event: React.MouseEvent<any>) => void | undefined) {
        return (e: React.MouseEvent<any>) => {
            this.getStore().dispatch({
                type: actionNavigation.NAVIGATION_UPDATEVIEW,
                value: newView
            });
        };
    }

    public static goBack(newView: string) {
        const backView = newView.slice(1);
        this.getStore().dispatch({
            type: actionNavigation.NAVIGATION_UPDATEVIEW,
            value: backView.substr(0, backView.indexOf("/"))
        });
    }

    /**
     * @description Show the Overlay with a custom text
     * @author Lucas Fridez <lucas@fridez.dev>
     * @static
     * @param {string} text text that will be showed
     * @memberof MainStore
     */
    public static showOverlay(text: string) {
        this.getStore().dispatch({
            text: text,
            type: actionsOverlayReducer.SHOW_OVERLAY
        });
    }

    /**
     * @description Hide the overlay and reset the text
     * @author Lucas Fridez <lucas@fridez.dev>
     * @static
     * @memberof MainStore
     */
    public static hideOverlay() {
        this.getStore().dispatch({
            type: actionsOverlayReducer.HIDE_OVERLAY
        });
    }

    public static showNotification(text: string, className = "") {
        this.getStore().dispatch({
            className: className,
            text: text,
            type: actionsNotificationReducer.SHOW_NOTIFICATION
        });
    }

    public static hideNotification() {
        this.getStore().dispatch({
            type: actionsNotificationReducer.HIDE_NOTIFICATION
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/stores/MainStore.ts